import { Component } from "@angular/core";

@Component({
    selector: "ifm-callback",
    template: "",
    standalone: false
})
export class CallbackComponent {}
